// extracted by mini-css-extract-plugin
export default {"app-template-root":"app-template-root-layout_app-template-root__SDxQE","ready":"app-template-root-layout_ready__AYklv"};